<template>
    <div class="runtime-custom-form">
        <div class="dynamic-attr-content"
            :style="{width: $pScreen.mainW}"
            ref="dynamicAttrContent">
            <div class="custom-form-top-img"
                :style="{height: 374*$pScreen.mainP+'px'}">
                <img :style="{width: $pScreen.mainW,height: 374*$pScreen.mainP+'px'}"
                    :src="activityPictureUrl"
                    alt>
            </div>
            <div class="completedTip">本次问卷活动已结束，感谢您的参与！</div>
            <div class="btn-tool align-center"
                style="margin-bottom: 48px;">
                <Button class="btn-submit"
                    :style="{width: $pScreen.textW,height: $pScreen.textH,fontSize:$pScreen.titleS}"
                    style="padding-top: 8px;"
                    v-on:click.stop="closePage">关闭</Button>
            </div>

            <!-- <div v-for="(item,index) in questionList" :key="index">
        <div class="dynamic-property-form">
          <component :attrObj="item" :is="item.questionType"></component>
        </div>
      </div> -->
        </div>
    </div>
</template>

<style scoped>
.is-item-required:before {
  content: '*';
  display: inline-block;
  margin-right: 4px;
  margin-top: -1px;
  line-height: 1;
  font-family: SimSun;
  font-size: 16px;
  color: #ed3f14;
}
.is-check-error {
  /* border: 1px solid #ed3f14; */
}
.radio-content {
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
  margin-bottom: 8px;
}
.radio-title {
  width: calc(100vw - 30px);
  /* font-size: 28px; */
  color: #333;
  padding: 10px 25px 8px 25px;
  font-size: 12px !important;
  font-weight: bold;
}
.runtime-custom-form .dynamic-attr-content {
  font-size: 24px;
  width: 750px;
  background-color: whitesmoke;
}
.runtime-custom-form .dynamic-attr-content .radio-options {
  width: calc(100vw - 30px);
  /* border-top: 1px solid #e4e4e4; */
  /* height: 80px; */
  display: inline-block;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #333333;
  height: 20px !important;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child {
  border-bottom: 0;
}
.runtime-custom-form .dynamic-attr-content .radio-options:last-child:after {
  height: 0;
}
.radio-options-content {
}
.radio-options-label {
  display: inline-block;
}
.radio-options-value {
  float: right;
}
/* .radio-options-value .ivu-icon {
  font-size: 24px;
} */
.radio-options-value .selected .ivu-icon {
  color: #00b1ff;
}
.dynamic-attr-text {
  page-break-before: always;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  /* align-items: center; */
  -ms-flex-pack: center;
  -webkit-box-pack: center;
  justify-content: center;
  flex-direction: column;
  background-color: #ffffff;
}
.dynamic-attr-text-title {
  width: 100%;
  /* font-size: 28px; */
  padding: 10px 0 8px 0;
  color: #333;
  font-weight: bold;
  font-size: 12px !important;
  display: block;
  /* align-items: center; */
}
.text-item-value {
  width: 100%;
  margin-bottom: 15px;
}
.text-item-value .ivu-input {
  font-size: 14px;
  /* color: #B2B2B2; */
}
.text-item-input .ivu-input {
  height: 32px;
}
.runtime-custom-form .ihr {
  margin: 0px 0px;
}

.dynamic-attr-file .ivu-upload-select button {
  background: #00b1ff;
  border-radius: 4px;
  color: #ffffff;
  /* width: 187px;
  height: 57px; */
  /* width: 93px; */
  height: 30px;
  font-size: 12px;
  width: 64px;
  padding: 0;
}
.ivu-btn > .ivu-icon {
  font-size: 16px;
}
.custom-form-title {
  width: 100%;
  line-height: 30px;
  text-align: center;
  background: #f578ff;
  color: #fff;
  font-size: 14px;
}
.ivu-input-wrapper {
  display: block !important;
  line-height: 1 !important;
}
.ivu-btn {
  border: 0 !important;
}
.scale-1px {
  position: relative;
  border: none !important;
}
.scale-1px:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
  content: ' ';
  background: #e5e5e5;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
}
.ihr {
  transform: scaleY(0.5);
}
.i-circle,
.i-check-circle {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/radio.png') no-repeat;
  background-size: 100%;
}
.i-check-circle {
  background-image: url('../../../../static/runtime/images/magic/radioSelected.png');
}
.i-circle:before,
.i-check-circle:before,
.i-square:before,
.i-check-square:before {
  content: ' ';
}
.i-square,
.i-check-square {
  width: 16px !important;
  height: 16px;
  background: url('../../../../static/runtime/images/magic/checkbox.png') no-repeat;
  background-size: 100%;
}
.i-check-square {
  background-image: url('../../../../static/runtime/images/magic/checkboxSelected.png');
}
.i-circle[disabled],
.i-check-circle[disabled],
.i-square[disabled],
.i-check-square[disabled] {
  opacity: 0.3;
}
.completedTip {
  font-size: 12px;
  text-align: center;
  margin: 30px 0;
}
</style>
<style scoped>
.runtime-custom-form .btn-submit {
  background-image: linear-gradient(46deg, #1dd3ff 0%, #f22efe 100%);
  border-radius: 87px;
  width: 690px;
  height: 78px;
  font-size: 28px;
  color: #ffffff;
}
</style>

<script>
import { directive as clickOutside } from '@/utils/component/v-click-outside-x';
import single_choice from './dynamicAttr/radio';
import multiple_choice from './dynamicAttr/checkbox';
import single_text from './dynamicAttr/input';
import multiple_text from './dynamicAttr/textarea';
import attachment from './dynamicAttr/selectedFile';
import form_time from './dynamicAttr/time';
import evaluation from './dynamicAttr/score';
import { getPosition } from '../../vibrantRubikCube/runtime/common-methods/utils';

export default {
  components: {
    single_choice,
    multiple_choice,
    single_text,
    multiple_text,
    attachment,
    form_time,
    evaluation,
  },
  directives: { clickOutside },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      dataList: [],
      formCustom: {},
      activityPictureUrl: '',
      activityCode: '',
      questionList: [],
      positionInfo: {},
    };
  },
  created() {
    this.initData();
  },
  //初始化后调用
  mounted: function () {},
  methods: {
    //加载表单问题数据
    async initData() {
      this.positionInfo =await getPosition();
      let self = this;
      self.activityCode = (self.$route.query && self.$route.query.activityCode) || (self.activityObj && self.activityObj.activityCode) || '';
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryMiniActivityQuestionDetail/' + self.activityCode,
        params: {
          longitude: self.positionInfo.longitude,
          dimension: self.positionInfo.latitude,
        },
        success: (r) => {
          console.log(r);
          let result = r.result || {},
            imageUrl = result.activityPictureUrl;
          imageUrl = JSON.parse(imageUrl);
          self.formCustom = result;
          self.activityPictureUrl = self.$utils.getImageUrl(imageUrl.file);
          let questionList = Object.assign({}, result.questionList);
          for (let i in questionList) {
            questionList[i].disabled = true;
          }
          self.questionList = questionList;
          self.queryUserAnswer();
        },
      });
    },
    //查询已提交数据
    queryUserAnswer() {
      let self = this;
      let userBase = self.$store.state.userInfo.userBase;
      let userUnionid = userBase.unionid || sessionStorage.getItem('userUnionid');
      let userOpenid = userBase.userOpenid || sessionStorage.getItem('userOpenid');
      let connectionId = '';
      let loginType = sessionStorage.getItem('loginType');
      let crtlParams = sessionStorage.getItem('crtlParams');
      if (crtlParams) {
        crtlParams = JSON.parse(crtlParams);
        loginType = crtlParams.loginType;
        connectionId = sessionStorage.getItem('connectionId');
      }
      let params = {
        activityCode: self.activityCode,
        userUnionid: userUnionid,
        loginType: loginType,
        userOpenid: userOpenid,
        connectionId: sessionStorage.getItem('connectionId'),
        associationActivityCode: sessionStorage.getItem('associationActivityCode'),
      };
      self.$api.post({
        sc: 'mobileMarketingH5',
        url: 'questionActivity/queryUserQuestionAnswer',
        params: params,
        success: (r) => {
          console.log(r);
          let questionList = self.questionList;
          let answerList = r.result || [];
          let typeArr = ['single_choice', 'multiple_choice'];
          if (answerList.length > 0) {
            for (let i in questionList) {
              for (let j in answerList) {
                if (answerList[j].questionType === 'evaluation') {
                  answerList[j].answerVO.answerContent = Number(answerList[j].answerVO.answerContent);
                }
                if (questionList[i].id == answerList[j].answerVO.questionId) {
                  if (typeArr.indexOf(questionList[i].questionType) > -1) {
                    let arr = answerList[j].answerVO.answerContent.split(',');
                    for (let k in arr) {
                      let arr2 = arr[k].split(':');
                      let optionList = questionList[i].optionList;
                      for (let m in optionList) {
                        if (optionList[m].optionCode == arr2[0]) {
                          optionList[m]._isSelect = true;
                        }
                      }
                    }
                  } else if (questionList[i].questionType == 'attachment') {
                    questionList[i].desc = self.$utils.getImageUrl(answerList[j].answerVO.answerContent);
                  } else {
                    questionList[i].answerContent = answerList[j].answerVO.answerContent;
                  }
                }
              }
            }
          }
        },
      });
    },
    closePage() {
      window.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/nps-form-submited.vue